import React from "react";
import PropTypes from "prop-types";

const LayoutTextBox = ({ data }) => {
  const { chartTitle, description, isTitleHidden, bgColor } = data;

  return (
    <div className="p-2 w-100 h-100" style={{ background: bgColor }}>
      {!isTitleHidden && (
        <div className="ql">
          <div className="ql-editor p-0 pb-1" style={{ textAlign: "center" }}>
            <div dangerouslySetInnerHTML={{ __html: chartTitle }}></div>
          </div>
        </div>
      )}
      <div className="ql">
        <div className="ql-editor">
          <div dangerouslySetInnerHTML={{ __html: description }}></div>
        </div>
      </div>
    </div>
  );
};

export default LayoutTextBox;

LayoutTextBox.propTypes = {
  data: PropTypes.object.isRequired,
};
